import "./App.css";
import Main from "./screens/main";

function App() {
	return (
		<div className='App overflow-hidden'>
			<Main />
		</div>
	);
}

export default App;
